<template>
  <div class="m-b-sm">
    <div class="has-text-centered">
      <router-link :to="{ name: 'Home' }">
        <img v-if="$store.getters.isMH" src="@/../static/muscle_heroes_logo.svg" class="is-inline-block is-xlarge icon" />
        <img v-else src="@/../static/keepyou.fit.svg" class="is-inline-block is-xlarge icon" />
      </router-link>
    </div>
    <span class="m-t-md m-r-md menu-icon" @click="showMenu">
      <img v-if="$store.getters.isMH" src="@/../static/svg/menu.svg" class="is-inline-block is-medium icon">
      <img v-else src="@/../static/kfit/menu.svg" class="is-inline-block is-medium icon">
    </span>
    <Menu ref="menu" :show="false" />
  </div>
</template>

<script>
import Menu from '@/components/Menu'

export default {
  name: 'Terms',
  methods: {
    showMenu () {
      this.$refs.menu.showMe()
    }
  },
  components: {
    Menu
  }
}
</script>

<style>
.menu-icon {
  opacity:0.5;
  position:absolute;
  top:1rem;
  right:0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue